module.exports = __webpack_public_path__ + "static/img/home_h122px_applets_icon_nor@2x.e84837b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home_h122px_applets_icon_nor@2x.png
// module id = 8UG3
// module chunks = 0